/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      parent_id: 'parent_id',
    car_status_type: 'car_status_type',
    name: 'name',
    status: 'status',

};
